import script from "./UploadFileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileModal.vue?vue&type=style&index=0&id=661b6240&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661b6240"]])

export default __exports__